<template>
	<div :class="['material-notification__item__alert', data.type]">
		<p>{{ data.message }}</p>
		<i class="fal fa-times-circle" role="button" @click="onClose"></i>
	</div>
</template>

<script>
export default {
	name: "NotificationAlert",
	props: {
		data: {
			type: [Object],
			required: true
		}
	},
	created() {
		if (Number.isInteger(this.data.timeout))
			this.timer = setTimeout(() => this.onClose(), this.data.timeout);
	},
	beforeDestroy() {
		clearTimeout(this.timer);
	},
	methods: {
		onClose() {
			this.$emit("notify-remove");
		}
	}
};
</script>

<style lang="scss" scoped>
.material-notification__item__alert {
	text-align: left;
	width: 100%;
	word-break: break-all;
	p {
		margin: 0;
	}
	&.info {
		background-color: #4894ec;
		color: #fff;
	}
	&.success {
		background-color: #67ad5b;
		color: #fff;
	}
	&.warning {
		background-color: #f6c344;
		color: #000;
	}
	&.error {
		background-color: #ec5f59;
		color: #fff;
	}
	i {
		align-self: center;
		color: #fff;
		cursor: pointer;
		font-size: 18px;
	}
}
</style>
